import { render } from "./S187315.vue?vue&type=template&id=70aa34f6"
const script = {}
script.render = render

export default script